import { render } from "./impactPage.vue?vue&type=template&id=0483cb36&scoped=true"
import script from "./impactPage.vue?vue&type=script&lang=js"
export * from "./impactPage.vue?vue&type=script&lang=js"

import "./impactPage.vue?vue&type=style&index=0&id=0483cb36&scoped=true&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0483cb36"]])

export default __exports__